export default __webpack_public_path__ + "static/media/confirmed.6bb88cef.svg";